export const Subheader = ({ text }: { text: string }) => (
  <div className="sm:text-2xl text-xl my-5 font-bold capitalize text-[#324B4A]">{text}</div>
);
